// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerAddressFormFieldStyles } from "@insite/content-library/Components/CustomerAddressFormFields";
import { css } from "styled-components";

customerAddressFormFieldStyles.firstNameGridItem = {
    width: [12, 6, 6, 6, 6]
};

customerAddressFormFieldStyles.lastNameGridItem = {
    width: [12, 6, 6, 6, 6]
};

customerAddressFormFieldStyles.companyNameGridItem = {
    width: 12
};

customerAddressFormFieldStyles.attentionGridItem = {
    width: 12
};

customerAddressFormFieldStyles.stateGridItem = {
    width: [12, 6, 6, 6, 6]
};

customerAddressFormFieldStyles.postalCodeGridItem = {
    width: [12, 6, 6, 6, 6]
};

customerAddressFormFieldStyles.phoneGridItem = {
    width: [12, 6, 6, 6, 6]
};

customerAddressFormFieldStyles.faxGridItem = {
    width: [12, 6, 6, 6, 6]
};
